export default __webpack_public_path__ + "static/media/whatsapp.fd41d0a2.svg";